import React, { useState, memo } from 'react'
import styled from 'styled-components'
import Main from './Main'

// enum UpdateTime {
//     pendding = 'pendding',
//     update = 'finished'
// }

const GMaps = props => {
    const { state, height, width, widget } = props

    const [layer, setLayer] = useState('0')
    const { update, group, select, attr, events, data, isLoading, isTimeToUpdate, isFirstLoad } = state

    // if (update == UpdateTime.pendding) return <div> Waiting for new events ... </div>

    const {
        jsonConfig = {
            key: 'digite a chave',
            steps: 5,
            zoom: 15,
            view: '',
            perspectives: [],
            btnFilters: [], // RETROCOMPATIBILIDADE
            btnFiltersOR: undefined,
            btnFiltersAND: [],
            maxSpeed: 120,
            extensionQualifier: '',
            positionsReportId: 116,
            tripsReportId: 0
        }
    } = widget || state

    return (
        <Main
            width={width}
            isLoading={isLoading}
            isTimeToUpdate={isTimeToUpdate}
            batch={data}
            options={jsonConfig}
            isFirstLoad={isFirstLoad}
        />
    )
}

export default memo(GMaps)
